import { S3 } from "../constants";

const Chat = (app) => {
  app.post(
    "/chat/group-chat-save",
    async ({ req, res, flash, api, assert, locals }) => {
      const { body, files = null } = req;
      const { participants, subject, allGroupChats } = body;
      const { activeUserToRequest } = locals;
      const groupChatsNames = allGroupChats ? JSON.parse(allGroupChats) : [];
      const isSubjectIncluded = groupChatsNames.includes(subject);

      assert(participants, 400, "You need to provide the participants");
      assert(subject, 400, "You need to provide the subject");
      assert(!isSubjectIncluded, 400, "This Group Chat name already exists");

      const participantsArray = JSON.parse(participants);

      const simplifiedParticipants = participantsArray.map(
        ({ _id, name, avatar }) => ({
          _id,
          name,
          ...(!!avatar && { avatar }),
        })
      );

      delete body.allGroupChats;

      let bodyToSend = {
        participants: simplifiedParticipants,
        subject,
      };

      if (!files.image) {
        const organizationLogo =
          activeUserToRequest.avatar && activeUserToRequest.avatar.s3Path
            ? `${S3.PATH}${activeUserToRequest.avatar.s3Path}`
            : "https://msbproduction.s3.us-west-2.amazonaws.com/misc/msb-logo.png";
        bodyToSend = { ...bodyToSend, organizationLogo };
      }

      try {
        await api(`create-group-chat`, {
          method: "POST",
          body: bodyToSend,
          files,
        });

        flash("success", "Chat group created successfully.");
      } catch (e) {
        flash("error", e.message);
      }
      res.redirect("/coaching-portal/chat");
    }
  );

  app.post(
    "/chat/group-chat-remove-members",
    async ({ req, res, flash, api, assert }) => {
      const { body } = req;
      const { participants, conversation } = body;

      assert(participants, 400, "You need to provide the participants");
      assert(conversation, 400, "You need to provide a conversation");

      try {
        await api(`remove-members-group-chat`, {
          method: "POST",
          body: {
            participants,
            conversation,
          },
        });

        flash("success", "Members deleted successfully.");
      } catch (e) {
        flash("error", e.message);
      }

      res.refreshWith(
        {
          modal: "",
          groupParticipants: "",
          groupSubject: "",
          groupChatId: "",
          groupImage: "",
          groupEdited: true,
          allGroupChats: "",
        },
        { url: "back", hash: "#_" }
      );
    }
  );

  app.post(
    "/chat/group-chat-add-members",
    async ({ req, res, flash, api, assert }) => {
      const { body } = req;
      const { participants, conversation } = body;

      assert(participants, 400, "You need to provide the participants");
      assert(conversation, 400, "You need to provide a conversation");

      const simplifiedParticipants = participants.map(({ _id, name }) => ({
        _id,
        name,
      }));

      try {
        await api(`add-members-group-chat`, {
          method: "POST",
          body: {
            participants: simplifiedParticipants,
            conversation,
          },
        });

        flash("success", "Members added successfully.");
      } catch (e) {
        flash("error", e.message);
      }
      res.refreshWith(
        {
          modal: "",
          groupParticipants: "",
          groupSubject: "",
          groupChatId: "",
          groupImage: "",
          groupEdited: true,
          allGroupChats: "",
        },
        { url: "back", hash: "#_" }
      );
    }
  );

  app.post(
    "/chat/group-chat-edit",
    async ({ req, res, flash, api, assert }) => {
      const { body, files = null } = req;
      const { subject, allGroupChats, conversationId } = body;
      //Converting the string to an array
      const groupChatsArray = allGroupChats ? JSON.parse(allGroupChats) : [];
      //Building an object array, before de @ are the ids, and after are the subjects
      const groupChats = groupChatsArray.map((chat) => {
        const [id, subject] = chat.split("@");
        return { id, subject };
      });

      const isSubjectBodyValid = !groupChats.some(
        (chat) => chat.subject === subject && chat.id !== conversationId
      );

      assert(subject, 400, "You need to provide the subject");
      assert(conversationId, 400, "You need to provide the conversation");
      assert(isSubjectBodyValid, 400, "This Group Chat name already exists");

      delete body.allGroupChats;

      try {
        await api(`edit-group-chat`, {
          method: "POST",
          body,
          files,
        });

        flash("success", "Chat group created successfully.");
      } catch (e) {
        flash("error", e.message);
      }
      res.refreshWith(
        {
          modal: "",
          groupParticipants: "",
          groupSubject: "",
          groupChatId: "",
          groupImage: "",
          groupEdited: true,
          allGroupChats: "",
        },
        { url: "back", hash: "#_" }
      );
    }
  );
};

export default Chat;
